import Vue from 'vue';
import { beforeRouteEnter } from '@assets/js/routerPageHook.js';
import onScrollAnimate from '@assets/js/scrollAnimate.js';
import formSteps from "@components/base/form-steps.vue";
import {mapGetters, mapState} from "vuex";
import {router} from "@src/routes";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',
            error: false,
            isAdded: false,
            visibleDelete: false,
        }
    },
    components: {
        'form-steps-cmp': formSteps,
    },
    computed: {
        ...mapState('mobile', ['isMobile']),
        ...mapGetters('lk', ['isAuth']),
    },
    methods: {
        errorData(data) {
            this.error = data.error;
        },
        scrollToForm(from) {
            // если перешли со страницы лк мероприятий
            if (from === 'lk-events') {
                setTimeout(() => {
                    this.$root.scrollToBlock('.js-reg-form');
                }, 1500);
            }
        },
        setIsAdded(bool) {
            if (this.isAuth) {
                this.isAdded = bool;
            }
        }
    },
    mounted() {
        setTimeout(() => {
            this.isAdded = document.querySelector('.js-btn') &&
                document.querySelector('.js-btn').classList.contains('_added');
        }, 10)
    },
    beforeRouteUpdate(to, from, next) {
        const path = to.path.replace(router.history.base, '');
        this.$root.setDataAnimateFalse();

        Vue.http.get(`templates${path}`, { params: to.query }).then(
            (data) => {
                next();
                setTimeout(() => {
                    this.template = data.data;
                    setTimeout(() => {
                        this.updateEvents();
                        onScrollAnimate();
                    }, 100);
                }, 500);
            },
            () => {
                next('/404');
            }
        );
    },
    beforeRouteEnter,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};


// WEBPACK FOOTER //
// ./src/templates/pages/events/view/index.js